import React from 'react';
import Container from '../layout/container';
import ContentWrapSC from './content-wrap.styled';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const ContentWrap = (props) => {
  const { children, className } = props;
  const customClass = classNames({ [className]: className !== '' });

  return (
    <ContentWrapSC className={customClass}>
      <Container>{children}</Container>
    </ContentWrapSC>
  );
};

ContentWrap.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

ContentWrap.defaultProps = {
  className: '',
};

export default ContentWrap;
